import React from 'react'
import NavBar from './navBar'
import Footer from './Footer'
import verified from "../../assets/verified.svg"
import free from "../../assets/freePackage.svg"
import premium from "../../assets/premPackage.svg"

const PricingPage = () => {
  return (
    <>
    <NavBar/>
    <div className='latest-product-feature'>
    <div className='latest-product-container'>
       <p className='latest-produt-url'>Home/Platform/Pricing</p>
        <p className='latest-product-head'>
            Pricing features
        </p>
        <p className='latest-product-desc'>Boost your job search with exclusive tools and personalized support or experience the core features of our platform at no cost!</p>
    </div>
    </div>
     <div className='latest-products-container' style={{display:"flex",flexDirection:"column",gap:"40px",margin:"0px auto",padding:"50px"}}>
         
             <div className="pricing-container">
                  <div className="pricing-card">
                    <div className='pricing-first-section'>
                    <div className="plan-type"><span className='center-plan-circle'style={{position:"relative"}}><img src={premium} style={{position:"absolute",top:"4px",right:"4px"}} alt='package'/></span><span style={{fontWeight:"700",fontSize:"28px",fontFamily:"Nunito Sans"}}>Professional</span></div>
                    <div className="plan-desc">
                      <button className='button-subscription-monthly' style={{backgroundColor:"rgba(26, 76, 255, 1)",color:"white"}}>Monthly</button>
                        <p className='plan-desc-detail'>
                            Find, shortlist, and hire your ideal candidates faster. Choose to
                      upgrade as it fits your hiring needs.
                        </p>
                    </div>
                   
                    </div>
                    <div className="features">
                        <p className='feature-heading'>Features</p>
                      <p className='feature-heading-list'><img src={verified} alt='verified'/><span>Access to unlimited Candidate Database</span></p>
                      <p className='feature-heading-list'><img src={verified} alt='verified'/><span>Host multiple Career Page Generator</span></p>
                      <p className='feature-heading-list'><img src={verified} alt='verified'/><span>Applicant Tracking System access</span></p>
                      <p className='feature-heading-list'><img src={verified} alt='verified'/><span>AI-Powered Smart Filters (Skills, Location)</span></p>
                    </div>
                    <div className="price-box">
                      <p className="price">$5</p>
                      <p className="per-month"> Per User/Month</p>
                      {/* <button className="upgrade-btn" onClick={""}>Upgrade</button> */}
                      
                    </div>
                  </div>
                 
              </div>
     </div>
    <Footer/>
    </>
  )
}

export default PricingPage